// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"bb05a2e8","93":"de3c0e3d","163":"19b756d7","184":"87b2ff8c","288":"27d00f9f","290":"a890392e","393":"8887619b","453":"075c88a1","578":"cf85707f","801":"083fa310","962":"9dc7fe19"}[chunkId] + ".chunk.js";
};